import { useUserStore } from '~/stores/user'
import {
  decideUserRoleAction,
  isSuperadminGatedRoute,
} from '~/utils/userRoleGate'

// Superadmin-only sections: System admin, the standalone question pages, and
// organisation settings pages that declare no permission. The rules live in the
// pure `decideUserRoleAction`.
export default defineNuxtRouteMiddleware(async (to) => {
  // Only super-gated sections need the role; skip loading the user store on
  // every other navigation.
  if (!isSuperadminGatedRoute(to.name)) return

  const userStore = useUserStore()

  // Resolve the role ourselves rather than relying on an earlier middleware
  // having initialised the store. Load failure → role unknown → treated as
  // non-super below (fail closed for a super-only section).
  try {
    await userStore.$ensureInitialised()
  } catch {
    // fall through with whatever state the store holds
  }

  // Non-super hitting a super-only section → 403, not a silent bounce to home.
  // Mirrors 05.access's "you don't belong here → /403" verdict so every
  // unauthorised access lands on the same explicit page. `/403` is a static
  // page (no organizationSlug param, name has no 'system-admin'), so this
  // guard early-exits on it — no redirect loop.
  const decision = decideUserRoleAction({
    routeName: to.name,
    declaresPermission: !!to.meta.permission,
    isSuperUser: userStore.isSuperUser,
  })
  if (decision.type === 'redirect') return navigateTo(decision.path)
})
